import { DOCUMENT, inject, Injectable } from '@angular/core';
import { AddressService } from './address.service';

@Injectable({
  providedIn: 'root'
})
export class AddressModalService {
  private observer: MutationObserver | null = null;
  private pcaDiv: HTMLElement | null = null;

  private readonly addressService = inject(AddressService);
  private readonly document = inject(DOCUMENT);

  // Move the PCA element to a new container
  // Only required for when address is in modal window
  // This can be called from modal window after it is opened and the PCA element is rendered
  movePca(targetContainer: HTMLElement): void {
    this.pcaDiv = this.document.body.querySelector('div.pca');
    if (this.pcaDiv) {
      this.pcaDiv.remove();
      this.addressService.resetScript();
    }

    this.observer = new MutationObserver((_mutations: Array<MutationRecord>, obs: MutationObserver) => {
      this.pcaDiv = this.document.body.querySelector('div.pca');
      if (this.pcaDiv) {
        this.pcaDiv = targetContainer.appendChild(this.pcaDiv);
        obs.disconnect();
      }
    });
    this.observer.observe(this.document.body, { childList: true });
  }

  resetPca(): void {
    this.observer?.disconnect();
    this.observer = null;
    if (this.pcaDiv) {
      this.pcaDiv.remove();
      this.pcaDiv = null;
      this.addressService.resetScript();
    }
  }
}
